import { render, staticRenderFns } from "./PortfolioFundSelect.vue?vue&type=template&id=7b6fdf85"
import script from "./PortfolioFundSelect.vue?vue&type=script&lang=js"
export * from "./PortfolioFundSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports